export const compactVehicleImg = require("../Assets/images/vehicle-Compact.png");
export const standardVehicleImg = require("../Assets/images/vehicle-Standard.png");
export const suvVehicleImg = require("../Assets/images/vehicle-SUV.png");
export const defaultImg = require("../Assets/images/default-img.jpg");
export const heroBG = require("../Assets/images/photo-1772032646716-a9c7b507e308.jpeg");
export const spotAddMobile = require("../Assets/images/spotie-add-spot.png");
// CRA 5 returns { default, ReactComponent } for SVG requires; PNGs/JPEGs
// return the URL string directly. Peel off .default so <img src={…}> gets
// a plain URL instead of the wrapper object.
export const playStoreImg = require("../Assets/images/Google_Play.png");
export const appStoreImg = require("../Assets/images/App_Store.png");
// export const playStoreImg = require("../Assets/images/playstore.svg").default;
// export const appStoreImg = require("../Assets/images/appstore.svg").default;
